import React, { Fragment, useContext } from "react";
import ChatAppContext from "../../../Chat";
import { Link } from "react-router-dom";
import { capitalize } from "../../Common/CommonFunction";
import CustomizerContext from "../../../_helper/Customizer";
import avatar from "../../../../src/assets/images/avatar.png";

const CurrentUser = () => {
  const { currentUser } = useContext(ChatAppContext) || {};

  return (
    <Fragment>
      {currentUser && (
        <div className="media">
          <img
            className="rounded-circle user-image"
            src={currentUser?.profile_image || avatar}
            alt="profile image"
          />

          <div className="about">
            <Link to={`${process.env.PUBLIC_URL}/app/users/profile`}>
              <div className="name f-w-600">
                {capitalize(currentUser.recruiter_full_name)}
              </div>
            </Link>
            <div className="status">{currentUser.status}</div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CurrentUser;
